import angular from 'angular';
import template from './template.html';
import './style.scss';

export class TFTButton {
    spin = false;

    buttonClick(event) {
        event.stopPropagation();

        this.onButtonClick(event);
    }
}

export const TFTButtonConfiguration = {
    template,
    bindings: {
        disabled: '<?',
        spin: '<?',
        className: '<?',
        labelKey: '@',
        icon: '<?',
        type: '<?',
        tooltipTextKey: '@',
        onButtonClick: '&',
        testId: '@',
    },
    controller: TFTButton,
    controllerAs: 'btnCtrl',
};

angular.module('TALENYA-FE').component('tftButton', TFTButtonConfiguration);
